.email {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
